
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';
import { DrillSkillService } from 'src/app/_services/drill-skill.service';

@Component({
  selector: 'app-drill-skill-show',
  templateUrl: './drill-skill-show.component.html',
  styleUrls: ['./drill-skill-show.component.css']
})
export class DrillSkillShowComponent implements OnInit {

  myForm:FormGroup
  server_drill_skill_id=0
  loading=true
  drillSkill:any=undefined
  errorSaving=false
  isSaving=false
  constructor(private adminService:DrillSkillService, private router:Router, private activatedRoute:ActivatedRoute) { }
  get f() {
    return this.myForm.controls
  }

  ngOnInit(): void {

 this.activatedRoute.params.subscribe(
  myP=>{
    this.server_drill_skill_id=myP['id']
    if(this.server_drill_skill_id==0){
      this.initMainFormFresh()
      this.loading=false
    }else{
      this.adminService.getDrillSkillItem(this.server_drill_skill_id).subscribe(
        d=>{
          this.drillSkill=d
          this.initMainFormShow()
          this.loading=false
        }
      )
    }


  }
)


  }
  on_submit(){
    this.isSaving=true
    let dd=this.formatData(this.myForm.value.name, this.myForm.value.drillCode,this.myForm.value.description)
    this.adminService.newDrillSkillItem(dd).subscribe(
      val=>{
        this.isSaving=false
        if(val['server_drill_skill_id']==0){
          this.errorSaving=true
        }
        else{
          this.router.navigate(['/admin/drill_skills/index'])
        }

      }
    )

  }
  formatData(name:string, explanation:string,skillCode:string){
    let data = new URLSearchParams();
    data.set('name', name);
    data.set('description', explanation);
    data.set('skillCode', skillCode);


    return data.toString()
  }






initMainFormFresh(){
  this.myForm=new FormGroup({
    name: new FormControl("", [Validators.required,Validators.minLength(4)]),
    skillCode: new FormControl("", [Validators.required,Validators.minLength(9)]),
    description: new FormControl("", [Validators.required,Validators.minLength(9)])
  });
}

initMainFormShow(){
  this.myForm=new FormGroup({
    name: new FormControl(this.drillSkill.name, [Validators.required,Validators.minLength(4)]),
    skillCode: new FormControl(this.drillSkill.skillCode, [Validators.required,Validators.minLength(9)]),
    description: new FormControl(this.drillSkill.description, [Validators.required,Validators.minLength(9)])
  });
}
}
